import _get from "lodash/get"
import { aemAxiosInstance } from "@/constants/api"
import {
  GLOBAL_CONFIGURATION_ENDPOINT,
  TotalSecsForaDay,
  postOrderNoOfDays,
} from "@/constants"
import { getOpenOrders, getPastOrders } from "@/store/features/orderSlice"
import { store } from "@/store"
import { findOrderByEmail } from "@/store/features/orderSlice"
import { MY_LISTS_PAGE_PATH } from "@/constants/routes"

export const getCardDetails = async ({ url, cardId }) => {
  try {
    const serviceList = await aemAxiosInstance({
      url: GLOBAL_CONFIGURATION_ENDPOINT,
      params: {
        path: url,
      },
    })
    if (serviceList?.data?.cardTypes) {
      const cardTypesList = await aemAxiosInstance({
        url: GLOBAL_CONFIGURATION_ENDPOINT,
        params: {
          path: serviceList?.data?.cardTypes,
        },
      })
      if (cardTypesList && cardTypesList.data) {
        const cardValueText =
          cardTypesList?.data?.find(card => card.value === cardId)?.text ?? ""
        return cardValueText
      } else {
        // log.error(
        //   "Card Details: Error occured while fetching data from AEM"
        // )
      }
    }
  } catch (error) {
    // log.error(error)
  }
}

export const setMenu = (info, i18n, language, isSaveProductToList = false) => {
  const {
    accountSettingsPath,
    myFavoritesPagePath,
    orderHistoryPath,
    myProductsPath,
    myServicesPath,
  } = info
  const urlsAndTitles = [
    { url: accountSettingsPath, title: i18n.accountSettings },
    {
      url: isSaveProductToList
        ? `/${language}${MY_LISTS_PAGE_PATH}`
        : myFavoritesPagePath,
      title: isSaveProductToList ? i18n.myLists : i18n.favorites,
    },
    { url: orderHistoryPath, title: i18n.orders },
    { url: myProductsPath, title: i18n.myProducts },
    { url: myServicesPath, title: i18n.myServices },
  ]

  return urlsAndTitles
    .filter(({ url }) => url)
    .map(({ url, title }) => ({ title, url }))
}

const getDaysDifference = orderDate => {
  const currentDate = new Date()
  const timeDiff = orderDate.getTime() - currentDate.getTime()
  const daysDiff = timeDiff / TotalSecsForaDay
  return daysDiff
}

export const fetchOrders = async () => {
  // #ToDo Make loading true
  const openOrders = []
  const pastOrders = []
  let postOrdersForUpsell = []

  const openData = await store
    .dispatch(getOpenOrders())
    .unwrap()
    .then(response => response)
  const pastData = await store
    .dispatch(getPastOrders())
    .unwrap()
    .then(response => response)
  openData.forEach(order => {
    const orderDate = new Date(_get(order, "createdAt", ""))
    const openDataArr = order.lineItems?.filter(
      item => !item.variant?.attributes?.find(attr => attr.name === "ComboSKU")
    )
    const lineItemsData = order.lineItems?.filter(
      item => !item.custom?.fields?.bundleParentId
    )
    const daysDiff = getDaysDifference(orderDate)
    openOrders.push({
      orderNo: _get(order, "orderNumber", ""),
      totalItems: openDataArr.reduce((a, b) => {
        return a + b.quantity
      }, 0),
      orderStatus: _get(order, "state.obj.name.en-US", ""),
      orderDate: `${orderDate.toLocaleString("default", {
        month: "long",
      })} ${orderDate.getDate()}, ${orderDate.getFullYear()}`,
      orderTotal: Number(
        _get(order, "taxedPrice.totalGross.centAmount", 0) / 100
      ).toFixed(2),
      lineItems: daysDiff < postOrderNoOfDays ? lineItemsData : [],
    })
  })
  pastData.forEach(order => {
    const orderDate = new Date(_get(order, "createdAt", ""))
    const pastDataArr = order.lineItems?.filter(
      item => !item.variant?.attributes?.find(attr => attr.name === "ComboSKU")
    )
    const lineItemsData = order.lineItems?.filter(
      item => !item.custom?.fields?.bundleParentId
    )
    const daysDiff = getDaysDifference(orderDate)

    pastOrders.push({
      orderNo: _get(order, "orderNumber", ""),
      totalItems: pastDataArr.reduce((a, b) => {
        return a + b.quantity
      }, 0),
      orderStatus: _get(order, "state.obj.name.en-US", ""),
      orderDate: `${orderDate.toLocaleString("default", {
        month: "long",
      })} ${orderDate.getDate()}, ${orderDate.getFullYear()}`,
      orderTotal: Number(
        _get(order, "taxedPrice.totalGross.centAmount", 0) / 100
      ).toFixed(2),
      lineItems: daysDiff < postOrderNoOfDays ? lineItemsData : [],
    })
  })
  const placedOrders = openOrders.concat(pastOrders)

  if (placedOrders.length) {
    postOrdersForUpsell = placedOrders
      .filter(item => item.orderStatus !== "Cancelled")
      .map(item => item.lineItems)
      .flat(1)
  }
  return { openOrders, pastOrders, postOrdersForUpsell }
}

/**
 *
 * @param {String} email
 * @param {String} orderNo
 * @return {String} order details page url
 */
export const fetchOrderDataByEmailOrderId = async (email, orderNo) => {
  return await store
    .dispatch(findOrderByEmail({ orderNo, email }))
    .unwrap()
    .then(response => response)
}
